import { Container } from '@tonic/shared/components/ui'
import { Section } from '@tonic/shared/components/ui'
import { Text } from '@tonic/shared/components/ui'
import { Stack } from '@tonic/shared/components/ui'
import { LoadingSpinner } from '@tonic/shared/components/ui'
import { Alert } from '@tonic/shared/components/ui'
import { AlertTitle } from '@tonic/shared/components/ui'
import { AlertDescription } from '@tonic/shared/components/ui'
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { KnowledgeGraphVisualization } from './knowledge-graph-visualization';
import { useQuery } from '@tanstack/react-query';
import { fetchGraphQL } from '../../../lib/graphql';

const GET_KNOWLEDGE_GRAPH = `
  query GetKnowledgeGraph {
    knowledgeGraph {
      nodes {
        id
        label
        type
      }
      edges {
        source
        target
        label
      }
    }
  }
`;

export function AILearningPage() {
  const { data, isLoading: loading, error } = useQuery({
    queryKey: ['knowledgeGraph'],
    queryFn: () => fetchGraphQL(GET_KNOWLEDGE_GRAPH),
  });

  return (
    <Container>
      <Section>
        <Stack space={6}>
          <Stack space={2}>
            <Text variant="h1">AI Learning</Text>
            <Text variant="body" className="text-muted-foreground">
              Visualize how our AI agents learn and connect information.
            </Text>
          </Stack>

          {loading && (
            <div className="flex justify-center py-8">
              <LoadingSpinner size="lg" />
            </div>
          )}

          {error && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertTitle>Error</AlertTitle>
              <AlertDescription>
                {error.message || 'Failed to load knowledge graph'}
              </AlertDescription>
            </Alert>
          )}

          {data && (
            <div className="border rounded-lg p-4 bg-background">
              <div className="h-[600px]">
                <KnowledgeGraphVisualization data={data.knowledgeGraph} />
              </div>
            </div>
          )}
        </Stack>
      </Section>
    </Container>
  );
}
